import { useCallback } from "react";

import useCurrentUser from "../../../hooks/useCurrentUser";
import { GenericObject } from "../../../types/generic.types";
import { AppResource } from "../../../types/resource.types";
import { requestCollRef } from "../../../utils/referencies";
import useNewNotification from "../../../components/notifications/new/useNewNotification";
import useCanceledNotification from "../../../components/notifications/new/useCanceledNotification";
import useIsAdmin from "../../../hooks/useIsAdmin";
import useIsAgent from "../../../hooks/useIsAgent";

const requestsQuery = (id: string, status: string) =>
  requestCollRef.where("ownerId", "==", id).where("status", "in", [status]);

// @ts-ignore
const useRequestNotifications = (agentType: GenericObject) => {
  const { user } = useCurrentUser();
  const { isAdmin } = useIsAdmin();
  const { isAgent } = useIsAgent();

  const pendingQuery = useCallback((id) => requestsQuery(id, "pending"), []);
  const canceledQuery = useCallback((id) => requestsQuery(id, "canceled"), []);

  const canProceed = useCallback(
    (data) => {
      return data.canceledBy.id !== user.id;
    },
    [user.id]
  );

  useNewNotification({
    query: pendingQuery,
    lastSeenAtField: AppResource.requestsLastSeenAt,
    resource: AppResource.visitsRequests,
    canReceiveNotifications: (isAgent || isAdmin) && agentType.isWeb,
  });

  useCanceledNotification({
    query: canceledQuery,
    lastSeenAtField: AppResource.requestsLastSeenAt,
    resource: AppResource.visitsRequests,
    canReceiveNotifications: (isAgent || isAdmin) && agentType.isWeb,
    canProceed,
  });
};

export default useRequestNotifications;
